import useSite from "@casino/legacy/client/hooks/useSite";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import { cn, TypographyText } from "@workspace/frontend-ui";

const PrivacyPolicyLink: FC = () => {
  const { siteConfig } = useSite();

  return (
    <a
      className="inline cursor-pointer bg-transparent p-0 font-[inherit] text-primary no-underline"
      href={siteConfig.privacyPolicyLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <TypographyText as="span" variant="small">
        <Translate id="support.privacy_policy" />
      </TypographyText>
    </a>
  );
};

export default PrivacyPolicyLink;
